"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "setVisitorId", {
    enumerable: true,
    get: function() {
        return setVisitorId;
    }
});
var _uuidV4 = require("./uuidV4");
var _cookie = require("./cookie");
var setVisitorId = function() {
    return (0, _cookie.setCookie)({
        name: "visitor_id",
        value: (0, _uuidV4.generateUUID)(),
        exdays: 365
    });
};

//# sourceMappingURL=setVisitorId.js.map